<template>
  <div class="serve">
    <nav class="tip-title __fs-16 _fw-500">服务专区</nav>
    <van-tabs
      v-model="currentIndex"
      @change="changeTabs"
      @click="changeTabs"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(item, index) in list"
        :key="index"
      >
      <template #title >
        <p class="classify-title" :style="{background: item.remark }">{{ item.dictLabel }}</p>
      </template>
      <div class="content">
        <slot />
      </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'CommonTabs',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
      currentIndex: 0, // 当前列
      isFixed: false, // 是否吸顶
    }
  },
  methods: {
    changeTabs (currentIndex) {
      console.log(123444)
      this.$emit('change-tab', currentIndex)
    },
    scrollTabs (e) {
      if (this.isFixed === e.isFixed) {
        return
      }
      this.isFixed = e.isFixed
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}
</script>

<style lang="scss" scoped>
.serve {
  margin: 36px 20px 0px 20px;
  .tip-title {
    padding-left: 8px;
    border-left: 3px solid $main-color;
    border-radius: 2px;
    color: #282828;
    margin-bottom: 24px;
  }
  .classify-title {
    font-size: 12px;
    text-align: center;
    color: #fff;
    width:105px;
    line-height: 30px;
  }
  /deep/.van-tabs {
    .van-tab {
      width: 105px;
      height: 30px;
      margin-right: 10px;
      opacity: .4;
    }
    .van-tab--active {
      border-bottom: none;
      width: 105px;
      height: 36px;
      opacity: 1;
      background: #33a353;
      .classify-title {
        line-height: 36px;
      }
    }
    .van-tabs__nav--complete {
      padding: 0;
      display: flex;
      align-items: flex-end;
    }
    .van-tabs__line {
      display: none;
    }
    .van-tabs__wrap{
      height: auto;
    }
  }
  .content {
    width: 100%;
    height: 440px;
    opacity: 1;
    background: #ffffff;
    box-shadow: -4px 0px 0px NaNpx rgba(149,149,149,0.30);
    padding-bottom: 24px;
    box-sizing: border-box;
  }
}
</style>
